import { ISearchFlight } from "@/shared/api/aviabooking/types"

export function getSearchFlightTotalPrice(flight: ISearchFlight): number {
    const price = flight.prices[0]
    if (!price) return 0

    const sum = price.fares.reduce((total, fare) => {
        return total + fare.quantity * fare.total_fare
    }, 0)

    return parseFloat(sum.toFixed(2))
}
